import { SubdistrictListPage } from "@/features/geolocation/page/SubdistrictListPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/geolocation/subdistrict/")({
  component: SubdistrictListPage,
});
